<template>
  <v-text-field
    v-bind="$attrs"
    :value="value"
    @input="handleInput"
    @blur="flush"
    @keydown.enter="flush"
    v-on="filteredListeners"
  />
</template>

<script>
export default {
  name: 'DebouncedTextField',
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    debounce: {
      type: Number,
      default: 200
    }
  },
  data() {
    return {
      debounceTimer: null,
      // what was typed but not yet emitted; enter or leaving the field emits it straight away
      pending: undefined
    }
  },
  computed: {
    filteredListeners() {
      // eslint-disable-next-line no-unused-vars
      const {input, ...listeners} = this.$listeners;
      return listeners;
    }
  },
  methods: {
    handleInput(value) {
      clearTimeout(this.debounceTimer);
      this.pending = value;
      this.debounceTimer = setTimeout(this.flush, this.debounce);
    },
    flush() {
      clearTimeout(this.debounceTimer);
      if (this.pending !== undefined) {
        const value = this.pending;
        this.pending = undefined;
        this.$emit('input', value);
      }
    }
  },
  beforeDestroy() {
    clearTimeout(this.debounceTimer);
  }
}
</script>
